import { Utils } from "@/plugins/utils";

export default {
    namespaced: true,
    state: {
        lx3: null,
        insert: false,
        update: false,
        loading: false
    },
    getters: {
        
    },
    mutations: {
        set(state, lx3){
            state.lx3 = lx3
            if (lx3)
                state.update = true
        },
        initForm(state){
            state.insert = false
            state.update = false
        }
    },
    actions: {
        async find(store){
            store.state.loading = true
            store.commit("initForm")
            let payload = await this._vm.$axios.get("/Oryx/FiscalParameters/Find")
            .then(response => {
                let lx3 = Utils.ValidateAxiosResponse(response.data);
                store.commit("set", lx3)
                return true
            })
            .catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return false
            });
            store.state.loading = false
            return payload
        },
        save(store){
            if (store.state.update){
                store.dispatch("update")
                return
            }
            store.dispatch("insert")
        },
        async insert(store){
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
            await this._vm.$axios.post("/Oryx/FiscalParameters/Insert", store.state.lx3 )
            .then(response => {
                Utils.ValidateAxiosResponse(response.data);
                store.dispatch("find")
                return true
            })
            .catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return false
            });
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
        },
        async update(store){
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
            await this._vm.$axios.put("/Oryx/FiscalParameters/Update", store.state.lx3 )
            .then(response => {
                Utils.ValidateAxiosResponse(response.data);
                store.dispatch("find")
                return true
            })
            .catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return false
            });
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
        },
        async delete(store){
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, {root: true})
            await this._vm.$axios.delete("/Oryx/FiscalParameters/Delete")
            .then(response => {
                Utils.ValidateAxiosResponse(response.data);
                store.dispatch("find")
                return true
            })
            .catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return false
            });
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
        },
    }
}